export const STRING = 'STRING'
export const NUMBER = 'NUMBER'
export const DATE = 'DATE'
export const BOOLEAN = 'BOOLEAN'
export const SELECT = 'SELECT'
export const DEFAULT = 'DEFAULT'
export const DATE_NUMBER = 'DATE_NUMBER'

export const KEY = 'keyField'
export const OPERATOR = 'operator'
export const VALUE = 'valueField'
export const CONDITION = 'condition'
export const SUBCONDITION = 'subCondition'

export const EQUAL = 'EQUAL'
export const NOT_EQUAL = 'NOT_EQUAL'
export const GTE = 'GTE'
export const GT = 'GT'
export const LTE = 'LTE'
export const LT = 'LT'
export const OLDER_THAN = 'OLDER_THAN'

export const NOW_PREFIX = {
  label: ' Now - ',
  value: ' CURRENT_DATE - INTERVAL '
}

export const initialState = {
  [KEY]: { label: '', value: '', type: DEFAULT, options: [] },
  [OPERATOR]: { label: '', value: '' },
  [VALUE]: { label: '', value: '' },
  [SUBCONDITION]: { label: '', value: '' },
  [CONDITION]: { label: '', value: '' }
}
export const initialRuleState = { label: '', value: '' }

export const operatorsMap = {
  [EQUAL]: { label: [EQUAL], value: '=' },
  [NOT_EQUAL]: { label: [NOT_EQUAL], value: '<>' },
  [GTE]: { label: [GTE], value: '>=' },
  [GT]: { label: [GT], value: '>' },
  [LTE]: { label: [LTE], value: '<=' },
  [LT]: { label: [LT], value: '<' },
  [OLDER_THAN]: { label: [OLDER_THAN], value: '<=' }
}

export const conditions = {
  AND: {
    label: `\n and \n`,
    value: ' AND '
  },
  OR: {
    label: `\n or \n`,
    value: ' OR '
  },
  OPENSUBCONDITION: {
    label: `( \n`,
    value: '('
  },
  CLOSESUBCONDITION: {
    label: `\n )`,
    value: ')'
  }
}

export const operatorsByFieldMap = {
  STRING: [operatorsMap.EQUAL, operatorsMap.NOT_EQUAL],
  NUMBER: [
    operatorsMap.EQUAL,
    operatorsMap.NOT_EQUAL,
    operatorsMap.GTE,
    operatorsMap.GT,
    operatorsMap.LTE,
    operatorsMap.LT
  ],
  DATE: [
    operatorsMap.EQUAL,
    operatorsMap.NOT_EQUAL,
    operatorsMap.GTE,
    operatorsMap.GT,
    operatorsMap.LTE,
    operatorsMap.LT,
    operatorsMap.OLDER_THAN
  ],
  BOOLEAN: [operatorsMap.EQUAL, operatorsMap.NOT_EQUAL],
  SELECT: [operatorsMap.EQUAL, operatorsMap.NOT_EQUAL],
  DATE_NUMBER: [
    operatorsMap.EQUAL,
    operatorsMap.NOT_EQUAL,
    operatorsMap.GTE,
    operatorsMap.GT,
    operatorsMap.LTE,
    operatorsMap.LT
  ]
}

export const defaultGeneratorConfig = {
  fields: []
}
